(function () {
  "use strict";

  if (window.__goldenRoomRuntime) {
    window.__goldenRoomRuntime.refresh();
    return;
  }

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasGSAP = typeof window.gsap !== "undefined";
  var hasST = hasGSAP && typeof window.ScrollTrigger !== "undefined";
  var hasSplit = hasGSAP && typeof window.SplitText !== "undefined";
  var $ = function (selector, context) { return (context || document).querySelector(selector); };
  var $$ = function (selector, context) { return Array.prototype.slice.call((context || document).querySelectorAll(selector)); };
  var leadConfig = window.ALIA_CFG || {};
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var clamp = function (value, min, max) { return value < min ? min : (value > max ? max : value); };
  var AMBER = "138,95,58";
  var BONE = "238,237,227";
  var DPRCAP = Math.min(window.devicePixelRatio || 1, 2);
  var scopes = new Map();
  var controllers = new Set();
  var crossCleanups = [];
  var pageBooted = Boolean(window.__goldenRoomPageBooted);

  function sectionRoot(node) {
    if (!node || node === document) return document;
    if (node.classList && node.classList.contains("shopify-section")) return node;
    return node.closest ? (node.closest(".shopify-section") || node) : node;
  }

  function sectionKey(node) {
    var root = sectionRoot(node);
    if (root === document) return "__document";
    return root.id || (root.dataset.goldenRoomScope || (root.dataset.goldenRoomScope = "golden-room-" + Math.random().toString(36).slice(2)));
  }

  function cleanupThing(thing) {
    if (!thing) return;
    if (thing.scrollTrigger) thing.scrollTrigger.kill(true);
    if (typeof thing.kill === "function") thing.kill();
    else if (typeof thing.revert === "function") thing.revert();
    else if (typeof thing.disconnect === "function") thing.disconnect();
  }

  function own(scope, thing) {
    if (!scope || !thing) return thing;
    scope.cleanups.push(function () { cleanupThing(thing); });
    return thing;
  }

  function ownCleanup(scope, cleanup) {
    if (scope && typeof cleanup === "function") scope.cleanups.push(cleanup);
    return cleanup;
  }

  function cleanupScope(nodeOrKey) {
    var key = typeof nodeOrKey === "string" ? nodeOrKey : sectionKey(nodeOrKey);
    var scope = scopes.get(key);
    if (!scope) return;
    for (var i = scope.cleanups.length - 1; i >= 0; i--) {
      try { scope.cleanups[i](); } catch (error) {}
    }
    scopes.delete(key);
  }

  function newScope(root) {
    var key = sectionKey(root);
    cleanupScope(key);
    var scope = { key: key, root: sectionRoot(root), cleanups: [] };
    scopes.set(key, scope);
    return scope;
  }

  function cleanupCrossBindings() {
    for (var i = crossCleanups.length - 1; i >= 0; i--) {
      try { crossCleanups[i](); } catch (error) {}
    }
    crossCleanups = [];
  }

  function ownCross(thing) {
    if (!thing) return thing;
    crossCleanups.push(function () { cleanupThing(thing); });
    return thing;
  }

  /* One Lenis instance, synchronized to the one ScrollTrigger registry. */
  var lenis = null;
  if (hasGSAP && hasST) {
    gsap.registerPlugin(ScrollTrigger);
    if (hasSplit) {
      try { gsap.registerPlugin(SplitText); } catch (error) {}
    }
    if (typeof window.Lenis !== "undefined" && !reduce) {
      try {
        lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1, smoothWheel: true });
        lenis.on("scroll", ScrollTrigger.update);
        gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
        gsap.ticker.lagSmoothing(0);
        window.__lenis = lenis;
      } catch (error) {
        lenis = null;
      }
    }
  }

  /* Doors countdown: Thu/Fri/Sat at 19:00 in the visitor's local time. */
  var DOOR_DAYS = [4, 5, 6];
  var DOOR_HOUR = 19;
  var DAYNAMES = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];

  function nextDoors(now) {
    for (var add = 0; add <= 7; add++) {
      var date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + add, DOOR_HOUR, 0, 0, 0);
      if (DOOR_DAYS.indexOf(date.getDay()) !== -1 && date.getTime() > now.getTime()) return date;
    }
    return null;
  }

  function serviceState(now) {
    var schedule = [{ d: 4, close: 6 }, { d: 5, close: 7 }, { d: 6, close: 7 }];
    for (var i = 0; i < schedule.length; i++) {
      for (var back = 0; back <= 1; back++) {
        var start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - back, DOOR_HOUR, 0, 0, 0);
        if (start.getDay() === schedule[i].d) {
          var end = new Date(start.getTime() + schedule[i].close * 3600000);
          if (now.getTime() >= start.getTime() && now.getTime() < end.getTime()) return { open: true, close: end };
        }
      }
    }
    return { open: false };
  }

  function pad(number) {
    return (number < 10 ? "0" : "") + number;
  }

  function setText(selector, value) {
    var node = $(selector);
    if (node) node.textContent = value;
  }

  function tickCountdown() {
    var now = new Date();
    var service = serviceState(now);
    var countdown = $("#cd");

    if (service.open) {
      var minutes = Math.max(0, Math.round((service.close.getTime() - now.getTime()) / 60000));
      if (countdown) countdown.classList.add("open");
      setText("#cdLabel", "DOORS ARE OPEN");
      setText("#cdWhen", "THE ROOM IS ALIVE");
      setText("#cdD", "00");
      setText("#cdH", "00");
      setText("#cdM", pad(Math.floor(minutes / 60)));
      setText("#cdS", pad(minutes % 60));
      setText("#chipTxt", "DOORS OPEN NOW");
      setText("#resLabel", "OPEN · LAST CALL IN");
      setText("#resD", "00");
      setText("#resH", pad(Math.floor(minutes / 60)));
      setText("#resM", pad(minutes % 60));
      setText("#resS", "00");
      return;
    }

    if (countdown) countdown.classList.remove("open");
    setText("#cdLabel", "NEXT DOORS");
    var doors = nextDoors(now);
    if (!doors) return;
    var seconds = Math.floor(Math.max(0, doors.getTime() - now.getTime()) / 1000);
    var days = Math.floor(seconds / 86400);
    seconds -= days * 86400;
    var hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    var minutesLeft = Math.floor(seconds / 60);
    seconds -= minutesLeft * 60;

    setText("#cdWhen", DAYNAMES[doors.getDay()] + " · 7:00 PM");
    setText("#cdD", pad(days));
    setText("#cdH", pad(hours));
    setText("#cdM", pad(minutesLeft));
    setText("#cdS", pad(seconds));
    setText("#resD", pad(days));
    setText("#resH", pad(hours));
    setText("#resM", pad(minutesLeft));
    setText("#resS", pad(seconds));
    setText("#resLabel", "NEXT DOORS IN");
    setText("#chipTxt", days > 0 ? "DOORS IN " + days + "D " + pad(hours) + "H" : (hours > 0 ? "DOORS IN " + hours + "H " + pad(minutesLeft) + "M" : "DOORS IN " + minutesLeft + "M " + pad(seconds) + "S"));
  }

  tickCountdown();
  window.setInterval(tickCountdown, 1000);

  function drawBeam(context, width, height, centerX, centerY, angle, halfWidth, intensity, hot) {
    var dx = Math.cos(angle);
    var dy = Math.sin(angle);
    var nx = -Math.sin(angle);
    var ny = Math.cos(angle);
    var length = Math.max(width, height) * 1.5;

    function quad(size, alpha, rgb) {
      var gradient = context.createLinearGradient(centerX - nx * size, centerY - ny * size, centerX + nx * size, centerY + ny * size);
      gradient.addColorStop(0, "rgba(" + rgb + ",0)");
      gradient.addColorStop(0.5, "rgba(" + rgb + "," + alpha + ")");
      gradient.addColorStop(1, "rgba(" + rgb + ",0)");
      context.fillStyle = gradient;
      context.beginPath();
      context.moveTo(centerX - dx * length - nx * size, centerY - dy * length - ny * size);
      context.lineTo(centerX + dx * length - nx * size, centerY + dy * length - ny * size);
      context.lineTo(centerX + dx * length + nx * size, centerY + dy * length + ny * size);
      context.lineTo(centerX - dx * length + nx * size, centerY - dy * length + ny * size);
      context.closePath();
      context.fill();
    }

    quad(halfWidth, 0.16 * intensity, AMBER);
    quad(halfWidth * 0.42, 0.46 * intensity, AMBER);
    if (hot > 0) quad(halfWidth * 0.12, 0.42 * hot, BONE);
  }

  var beamModel = [
    [[0, -20, .18, .30, .070, .45], [.34, -7, .5, .46, .055, .9], [.67, -3, .5, .5, .05, 1], [1, 0, .5, .5, .052, 1]],
    [[0, 22, .82, .26, .065, .45], [.34, 8, .5, .5, .052, .85], [.67, 3, .5, .5, .048, 1], [1, 0, .5, .5, .05, 1]],
    [[0, -42, .10, .72, .045, .30], [.34, -30, .35, .62, .045, .55], [.67, -16, .5, .56, .055, .85], [1, -8, .5, .54, .06, .95]],
    [[0, 44, .90, .74, .045, .30], [.34, 30, .66, .62, .045, .55], [.67, 16, .5, .55, .055, .85], [1, 8, .5, .54, .06, .95]]
  ];

  function sampleBeam(stops, progress) {
    var index = 0;
    for (; index < stops.length - 1; index++) {
      if (progress <= stops[index + 1][0]) break;
    }
    var from = stops[Math.min(index, stops.length - 1)];
    var to = stops[Math.min(index + 1, stops.length - 1)];
    var amount = clamp((progress - from[0]) / ((to[0] - from[0]) || 1), 0, 1);
    return {
      ang: lerp(from[1], to[1], amount) * Math.PI / 180,
      cx: lerp(from[2], to[2], amount),
      cy: lerp(from[3], to[3], amount),
      hw: lerp(from[4], to[4], amount),
      inten: lerp(from[5], to[5], amount)
    };
  }

  function createHeroCanvas(canvas) {
    var context = canvas && canvas.getContext("2d");
    if (!context) return null;
    var width = 0;
    var height = 0;
    var active = false;
    var frame = 0;
    var observer = null;
    var started = performance.now();

    function size() {
      var rect = canvas.getBoundingClientRect();
      width = canvas.width = Math.max(2, Math.round(Math.min(rect.width, 1800) * DPRCAP));
      height = canvas.height = Math.max(2, Math.round(Math.min(rect.height, 1400) * DPRCAP));
    }

    function render(time) {
      context.clearRect(0, 0, width, height);
      context.fillStyle = "rgba(36,26,17,0)";
      context.fillRect(0, 0, width, height);
      context.globalCompositeOperation = "lighter";
      var beams = [
        { baseAng: -14, ang: 8, cx: .30, cy: .34, hw: .10, sp: .18, ph: 0, inten: .7 },
        { baseAng: 16, ang: 9, cx: .72, cy: .40, hw: .09, sp: .15, ph: 2.1, inten: .6 },
        { baseAng: -34, ang: 6, cx: .5, cy: .72, hw: .07, sp: .12, ph: 4, inten: .45 }
      ];
      for (var i = 0; i < beams.length; i++) {
        var beam = beams[i];
        var angle = (beam.baseAng + Math.sin(time * beam.sp + beam.ph) * beam.ang) * Math.PI / 180;
        var centerX = (beam.cx + Math.sin(time * beam.sp * .7 + beam.ph) * .05) * width;
        var centerY = (beam.cy + Math.cos(time * beam.sp * .9 + beam.ph) * .03) * height;
        var intensity = beam.inten * (.85 + .15 * Math.sin(time * .8 + beam.ph));
        drawBeam(context, width, height, centerX, centerY, angle, beam.hw * Math.min(width, height) * 2.2, intensity, 0);
      }
      context.globalCompositeOperation = "source-over";
    }

    function loop() {
      if (!active) {
        frame = 0;
        return;
      }
      render((performance.now() - started) / 1000);
      frame = requestAnimationFrame(loop);
    }

    function start() {
      if (active && !frame) frame = requestAnimationFrame(loop);
    }

    function resize() {
      size();
      render(reduce ? 0 : (performance.now() - started) / 1000);
    }

    function dispose() {
      active = false;
      if (frame) cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
      controllers.delete(controller);
    }

    size();
    if (reduce) {
      render(0);
    } else if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          active = entry.isIntersecting;
          if (active) start();
        });
      }, { threshold: .02 });
      observer.observe(canvas);
      render(0);
    } else {
      active = true;
      render(0);
      start();
    }

    var controller = { resize: resize, render: render, dispose: dispose };
    controllers.add(controller);
    return controller;
  }

  function createBeamCanvas(canvas, section) {
    var context = canvas && canvas.getContext("2d");
    if (!context) return null;
    var beamCanvas = document.createElement("canvas");
    var beamContext = beamCanvas.getContext("2d");
    var textCanvas = document.createElement("canvas");
    var textContext = textCanvas.getContext("2d");
    var width = 0;
    var height = 0;
    var progress = 0;
    var active = false;
    var frame = 0;
    var observer = null;
    var started = performance.now();
    var words = [{ w: "ARRIVAL", c: .16 }, { w: "FIRST · DRINK", c: .5 }, { w: "PEAK", c: .84 }];

    function size() {
      var rect = canvas.getBoundingClientRect();
      width = canvas.width = Math.max(2, Math.round(Math.min(rect.width, 1800) * DPRCAP));
      height = canvas.height = Math.max(2, Math.round(Math.min(rect.height, 1200) * DPRCAP));
      beamCanvas.width = width;
      beamCanvas.height = height;
      textCanvas.width = width;
      textCanvas.height = height;
    }

    function fitFont(target, word, maxWidth) {
      var fontSize = Math.round(width * .115);
      target.font = "300 " + fontSize + "px Chivo, sans-serif";
      try { target.letterSpacing = Math.round(width * .008) + "px"; } catch (error) {}
      var measured = target.measureText(word).width;
      if (measured > maxWidth) {
        fontSize = Math.max(10, Math.floor(fontSize * maxWidth / measured));
        target.font = "300 " + fontSize + "px Chivo, sans-serif";
      }
    }

    function render(time) {
      beamContext.setTransform(1, 0, 0, 1, 0, 0);
      beamContext.clearRect(0, 0, width, height);
      beamContext.globalCompositeOperation = "lighter";
      var shimmer = 1 + Math.sin(time * 1.6) * .05;
      for (var i = 0; i < beamModel.length; i++) {
        var beam = sampleBeam(beamModel[i], progress);
        var hot = progress > .7 && i < 2 ? clamp((progress - .7) / .3, 0, 1) * beam.inten : 0;
        var centerY = beam.cy + Math.sin(time * .9 + i * 1.7) * .012;
        drawBeam(beamContext, width, height, beam.cx * width, centerY * height, beam.ang, beam.hw * Math.min(width, height) * 2.2, beam.inten * shimmer, hot);
      }
      beamContext.globalCompositeOperation = "source-over";

      context.clearRect(0, 0, width, height);
      context.fillStyle = "#241A11";
      context.fillRect(0, 0, width, height);
      var background = context.createRadialGradient(width * .5, height * .58, 0, width * .5, height * .58, Math.max(width, height) * .8);
      background.addColorStop(0, "rgba(74,51,31,0.35)");
      background.addColorStop(1, "rgba(36,26,17,0)");
      context.fillStyle = background;
      context.fillRect(0, 0, width, height);
      context.globalCompositeOperation = "lighter";
      context.drawImage(beamCanvas, 0, 0);
      context.globalCompositeOperation = "source-over";

      for (var wordIndex = 0; wordIndex < words.length; wordIndex++) {
        var word = words[wordIndex];
        var alpha = 1 - Math.min(1, Math.abs(progress - word.c) / .18);
        if (alpha <= .01) continue;
        var maxWidth = width * .84;
        context.save();
        fitFont(context, word.w, maxWidth);
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.globalAlpha = .055 * alpha;
        context.fillStyle = "#EEEDE3";
        context.fillText(word.w, width * .5, height * .5);
        context.restore();

        textContext.setTransform(1, 0, 0, 1, 0, 0);
        textContext.clearRect(0, 0, width, height);
        fitFont(textContext, word.w, maxWidth);
        textContext.textAlign = "center";
        textContext.textBaseline = "middle";
        textContext.globalAlpha = alpha;
        textContext.fillStyle = "#EEEDE3";
        textContext.fillText(word.w, width * .5, height * .5);
        textContext.globalCompositeOperation = "destination-in";
        textContext.drawImage(beamCanvas, 0, 0);
        textContext.globalCompositeOperation = "source-over";
        textContext.globalAlpha = 1;
        context.globalCompositeOperation = "lighter";
        context.drawImage(textCanvas, 0, 0);
        context.globalCompositeOperation = "source-over";
      }
    }

    function updateReadouts(value) {
      var movement = value < .34 ? 0 : (value < .67 ? 1 : 2);
      var moves = ["I · THE ARRIVAL", "II · THE FIRST DRINK", "III · THE ROOM AT ITS PEAK"];
      var roman = ["I", "II", "III"];
      var roomState = ["SETTLING", "ON THE BAR", "AT ITS PEAK"];
      var move = $("#rMove", section);
      var label = $("#buMove", section);
      var room = $("#rRoom", section);
      var lux = $("#rLux", section);
      if (move) move.textContent = moves[movement];
      if (label) label.textContent = "MOVEMENT " + roman[movement];
      if (room) room.textContent = roomState[movement];
      if (lux) lux.textContent = Math.round(lerp(120, 940, value));
    }

    function setProgress(value) {
      progress = value;
      updateReadouts(value);
      if (active && !frame) frame = requestAnimationFrame(loop);
      if (reduce) render(0);
    }

    function loop() {
      if (!active) {
        frame = 0;
        return;
      }
      render((performance.now() - started) / 1000);
      frame = requestAnimationFrame(loop);
    }

    function resize() {
      size();
      render(reduce ? 0 : (performance.now() - started) / 1000);
    }

    function dispose() {
      active = false;
      if (frame) cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
      controllers.delete(controller);
    }

    size();
    if (reduce) {
      progress = .84;
      updateReadouts(progress);
      render(0);
    } else if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          active = entry.isIntersecting;
          if (active && !frame) frame = requestAnimationFrame(loop);
        });
      }, { threshold: .02 });
      observer.observe(canvas);
      render(0);
    } else {
      active = true;
      render(0);
      frame = requestAnimationFrame(loop);
    }

    var controller = { resize: resize, render: render, setProgress: setProgress, dispose: dispose };
    controllers.add(controller);
    return controller;
  }

  function animateHero(scope) {
    if (!hasGSAP || reduce || !$("#hero", scope.root)) return;
    own(scope, gsap.timeline()
      .from($$(".hero-title .hl span", scope.root), { yPercent: 118, duration: 1.05, stagger: .14, ease: "power4.out" }, 0)
      .to($("#heroUnder", scope.root), { width: "min(280px,60vw)", duration: 1, ease: "power3.out" }, .5)
      .from($$(".hero-top .reveal", scope.root), { y: 18, opacity: 0, duration: .7, stagger: .1, ease: "power2.out" }, .15)
      .from($(".hero-sub", scope.root), { y: 22, opacity: 0, duration: .8, ease: "power2.out" }, .5)
      .from($(".corporate-capacity-quick", scope.root), { y: 26, opacity: 0, duration: .9, ease: "power3.out" }, .6)
      .from($$(".alia-entry-grid--hero .alia-entry-card", scope.root), { y: 24, opacity: 0, duration: .75, stagger: .1, ease: "power3.out" }, .72)
      .from($(".scrollcue", scope.root), { opacity: 0, duration: .7, ease: "power2.out" }, .9));
  }

  function initGenericAnimations(scope) {
    var root = scope.root;
    if (!hasGSAP || !hasST || reduce) {
      $$(".reveal", root).forEach(function (node) { node.style.opacity = 1; });
      $$(".hero-title .hl span", root).forEach(function (node) { node.style.transform = "none"; });
      var under = $("#heroUnder", root);
      if (under) under.style.width = "min(280px,60vw)";
      return;
    }

    $$(".reveal", root).forEach(function (node) {
      if (node.closest("#hero")) return;
      own(scope, gsap.from(node, {
        y: 34,
        opacity: 0,
        duration: .9,
        ease: "power3.out",
        scrollTrigger: { trigger: node, start: "top 88%" }
      }));
    });

    if (hasSplit) {
      $$("h2", root).forEach(function (heading) {
        if (heading.closest("#hero")) return;
        try {
          var split = new SplitText(heading, { type: "lines", linesClass: "sl-line" });
          gsap.set(split.lines, { overflow: "hidden" });
          ownCleanup(scope, function () { split.revert(); });
          own(scope, gsap.from(split.lines, {
            yPercent: 110,
            duration: 1,
            stagger: .12,
            ease: "power4.out",
            scrollTrigger: { trigger: heading, start: "top 86%" }
          }));
        } catch (error) {}
      });

      var quote = $(".quote", root);
      if (quote) {
        try {
          var quoteSplit = new SplitText(quote, { type: "words", wordsClass: "word" });
          $$(".quote .word", root).forEach(function (word) {
            var inner = document.createElement("span");
            while (word.firstChild) inner.appendChild(word.firstChild);
            word.appendChild(inner);
          });
          ownCleanup(scope, function () { quoteSplit.revert(); });
          own(scope, gsap.from($$(".quote .word span", root), {
            yPercent: 120,
            duration: 1,
            stagger: .09,
            ease: "power4.out",
            scrollTrigger: { trigger: quote, start: "top 82%" }
          }));
        } catch (error) {}
      }
    }
  }

  function initHero(scope) {
    var canvas = $("#heroBeams", scope.root);
    if (canvas) {
      var controller = createHeroCanvas(canvas);
      if (controller) ownCleanup(scope, controller.dispose);
    }
  }

  function initBeams(scope) {
    var section = $("#beams", scope.root);
    var canvas = $("#beamStage", scope.root);
    if (!section || !canvas) return;
    var controller = createBeamCanvas(canvas, section);
    if (controller) ownCleanup(scope, controller.dispose);

    if (hasGSAP && hasST && !reduce && controller) {
      var media = gsap.matchMedia();
      media.add("(min-width:821px)", function () {
        var trigger = ScrollTrigger.create({
          trigger: section,
          start: "top top",
          end: "+=340%",
          scrub: .5,
          pin: $(".beams-stage", section),
          anticipatePin: 1,
          onUpdate: function (self) { controller.setProgress(self.progress); }
        });
        controller.setProgress(0);
        return function () { trigger.kill(true); };
      });
      media.add("(max-width:820px)", function () {
        var stage = $(".beams-stage", section);
        var trigger = ScrollTrigger.create({
          trigger: section,
          start: "top top",
          end: "+=220%",
          scrub: .45,
          pin: stage,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onUpdate: function (self) { controller.setProgress(self.progress); }
        });
        controller.setProgress(0);
        return function () { trigger.kill(true); };
      });
      ownCleanup(scope, function () { media.revert(); });
    } else if (controller) {
      controller.setProgress(.84);
    }
  }

  function initSectionSpecificAnimations(scope) {
    var root = scope.root;
    initHero(scope);
    initBeams(scope);

    if (hasGSAP && hasST && !reduce) {
      var sweep = $("#glassSweep", root);
      if (sweep) {
        own(scope, gsap.fromTo(sweep, { xPercent: -130 }, {
          xPercent: 470,
          ease: "none",
          scrollTrigger: { trigger: $("#glassware", root), start: "top 70%", end: "bottom 30%", scrub: .8 }
        }));
      }

      var arcPeak = $("#arcPeak", root);
      var arc = $("#arc", root);
      if (arcPeak && arc) {
        var db = { v: 78 };
        own(scope, ScrollTrigger.create({
          trigger: arc,
          start: "top 80%",
          once: true,
          onEnter: function () {
            own(scope, gsap.to(db, {
              v: 96,
              duration: 1.6,
              ease: "power2.out",
              onUpdate: function () { arcPeak.textContent = Math.round(db.v); }
            }));
          }
        }));
      }

      var track = $(".foot-marquee .track", root);
      var footer = $("#footer", root);
      if (track && footer) {
        var footerMedia = gsap.matchMedia();
        footerMedia.add("(min-width:701px)", function () {
          var tween = gsap.to(track, {
            xPercent: -50,
            ease: "none",
            scrollTrigger: { trigger: footer, start: "top bottom", end: "bottom top", scrub: 1 }
          });
          return function () { tween.kill(); };
        });
        footerMedia.add("(max-width:700px)", function () {
          gsap.set(track, { clearProps: "transform" });
          return function () {};
        });
        ownCleanup(scope, function () { footerMedia.revert(); });
      }
    }

    var day = new Date().getDay();
    $$(".hours-row", root).forEach(function (row) {
      row.classList.toggle("now", parseInt(row.getAttribute("data-day"), 10) === day);
    });
  }

  function initScope(root, isEditorLoad) {
    var scope = newScope(root);
    initGenericAnimations(scope);
    initSectionSpecificAnimations(scope);

    var preloader = $("#pre", scope.root);
    if (preloader && pageBooted) preloader.classList.add("gone");
    if (isEditorLoad && pageBooted && $("#hero", scope.root)) animateHero(scope);
    if (pageBooted) {
      var dock = $(".alia-cta-dock", scope.root);
      if (dock) dock.classList.add("revealed");
    }
    return scope;
  }

  function rebuildCrossBindings() {
    cleanupCrossBindings();
    if (!hasGSAP || !hasST || reduce) return;
    var nav = $("#nav");
    var chip = $("#navChip");
    var hero = $("#hero");
    if (nav && hero) {
      ownCross(ScrollTrigger.create({
        trigger: hero,
        start: "bottom 80%",
        onEnter: function () {
          nav.classList.add("shrunk");
          if (chip) chip.classList.add("on");
        },
        onLeaveBack: function () {
          nav.classList.remove("shrunk");
          if (chip) chip.classList.remove("on");
        }
      }));
    }

    var progress = $("#progress");
    if (progress) {
      ownCross(ScrollTrigger.create({
        trigger: document.body,
        start: "top top",
        end: "bottom bottom",
        scrub: true,
        onUpdate: function (self) { progress.style.width = self.progress * 100 + "%"; }
      }));
    }
  }

  function revealDock() {
    $$(".alia-cta-dock").forEach(function (dock) { dock.classList.add("revealed"); });
  }

  function runPreloader() {
    var preloader = $("#pre");
    if (!preloader) {
      pageBooted = true;
      window.__goldenRoomPageBooted = true;
      revealDock();
      scopes.forEach(function (scope) {
        if ($("#hero", scope.root)) animateHero(scope);
      });
      return;
    }

    if (pageBooted) {
      preloader.classList.add("gone");
      revealDock();
      return;
    }

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      pageBooted = true;
      window.__goldenRoomPageBooted = true;
      preloader.classList.add("gone");
      revealDock();
      scopes.forEach(function (scope) {
        if ($("#hero", scope.root)) animateHero(scope);
      });
      if (hasST) window.setTimeout(function () { ScrollTrigger.refresh(); }, 60);
    }

    var scope = scopes.get(sectionKey(preloader));
    var letters = $$(".pre-word span", preloader);
    var bar = $(".pre-bar i", preloader);
    var number = $("#preNum", preloader);

    if (hasGSAP && !reduce) {
      var counter = { value: 0 };
      own(scope, gsap.timeline({ onComplete: finish })
        .to(letters, { yPercent: -115, opacity: 1, stagger: .09, duration: .6, ease: "power3.out" }, .05)
        .to(bar, { scaleX: 1, duration: 1.15, ease: "power2.inOut" }, .1)
        .to(counter, {
          value: 100,
          duration: 1.15,
          ease: "power2.inOut",
          onUpdate: function () { if (number) number.textContent = Math.round(counter.value); }
        }, .1)
        .to(letters, { yPercent: -230, opacity: 0, stagger: .05, duration: .4, ease: "power2.in" }, 1.55)
        .to([$(".pre-bar", preloader), $(".pre-meta", preloader)], { opacity: 0, duration: .3 }, 1.55));
    } else {
      if (number) number.textContent = "100";
      letters.forEach(function (letter) {
        letter.style.transform = "none";
        letter.style.opacity = "1";
      });
      window.setTimeout(finish, 300);
    }
    window.setTimeout(finish, 2500);
  }

  function initAllSections() {
    var roots = $$(".shopify-section");
    if (!roots.length) roots = [document];
    roots.forEach(function (root) { initScope(root, false); });
  }

  initAllSections();
  setHelp(false);
  rebuildCrossBindings();
  runPreloader();

  if (!hasGSAP || !hasST || reduce) {
    var settledNav = $("#nav");
    var settledChip = $("#navChip");
    window.addEventListener("scroll", function () {
      if (!settledNav) return;
      var on = window.scrollY > window.innerHeight * .7;
      settledNav.classList.toggle("shrunk", on);
      if (settledChip) settledChip.classList.toggle("on", on);
    }, { passive: true });
  }

  if (!reduce && window.matchMedia("(hover:hover)").matches) {
    var cursor = $("#cursor");
    var cursorDot = $("#cursorDot");
    var mouseX = innerWidth / 2;
    var mouseY = innerHeight / 2;
    var cursorX = mouseX;
    var cursorY = mouseY;

    window.addEventListener("mousemove", function (event) {
      mouseX = event.clientX;
      mouseY = event.clientY;
      if (cursorDot) cursorDot.style.transform = "translate(" + mouseX + "px," + mouseY + "px)";
    }, { passive: true });

    (function cursorLoop() {
      cursorX = lerp(cursorX, mouseX, .18);
      cursorY = lerp(cursorY, mouseY, .18);
      if (cursor) cursor.style.transform = "translate(" + cursorX + "px," + cursorY + "px)";
      requestAnimationFrame(cursorLoop);
    })();

    var largeTargets = "a,button,.mi,.faq-q,.btn,.brand,#navChip,.mv-cell,.gw-cat,.alia-entry-card,.alia-help-fab";
    document.addEventListener("mouseover", function (event) {
      if (event.target.closest && event.target.closest(largeTargets)) document.body.classList.add("cur-lg");
    });
    document.addEventListener("mouseout", function (event) {
      if (event.target.closest && event.target.closest(largeTargets)) document.body.classList.remove("cur-lg");
    });
  }

  function setMenu(open) {
    var nav = $("#nav");
    var toggle = $("[data-alia-menu-toggle]");
    if (!nav || !toggle) return;
    nav.classList.toggle("menu-open", open);
    toggle.setAttribute("aria-expanded", String(open));
  }

  function setHelp(open) {
    var panel = $("#aliaHelpPanel");
    var toggle = $("[data-alia-help-toggle]");
    if (!panel || !toggle) return;
    panel.hidden = !open;
    panel.setAttribute("aria-hidden", String(!open));
    toggle.setAttribute("aria-expanded", String(open));
    toggle.textContent = "?";
    var shell = toggle.closest(".alia-help-shell");
    if (shell) shell.classList.toggle("is-open", open);
  }

  function localDateMinimum() {
    var now = new Date();
    var month = String(now.getMonth() + 1).padStart(2, "0");
    var day = String(now.getDate()).padStart(2, "0");
    return now.getFullYear() + "-" + month + "-" + day;
  }

  var enquirySentKey = "aliaCorporateEnquirySent";

  function savedEnquiry() {
    try {
      return JSON.parse(window.sessionStorage.getItem(enquirySentKey) || "null");
    } catch (error) {
      return null;
    }
  }

  function rememberEnquiry(data) {
    try {
      window.sessionStorage.setItem(enquirySentKey, JSON.stringify({ data: data }));
    } catch (error) {
      /* The confirmation still works when storage is unavailable. */
    }
  }

  function forgetEnquiry() {
    try {
      window.sessionStorage.removeItem(enquirySentKey);
    } catch (error) {
      /* The form can still be reset when storage is unavailable. */
    }
  }

  var summaryFields = [
    "Name", "Company", "Email", "Phone", "Event type", "Event detail",
    "Guests", "Preferred date", "Budget per head"
  ];

  function renderEnquirySummary(dialog, data) {
    var summary = $("#aliaEnquirySummary", dialog);
    if (!summary) return;
    summary.innerHTML = "";
    summaryFields.forEach(function (name) {
      var value = String((data || {})[name] || "").trim();
      if (!value) return;
      var row = document.createElement("div");
      var term = document.createElement("dt");
      var description = document.createElement("dd");
      term.textContent = name;
      description.textContent = name === "Preferred date" ? niceEnquiryDate(value) : value;
      row.appendChild(term);
      row.appendChild(description);
      summary.appendChild(row);
    });
  }

  function resetEnquiryForm(dialog, focusFirst) {
    var form = $("#aliaEnquiryForm", dialog);
    var done = $("#aliaEnquiryDone", dialog);
    if (!form) return;
    form.reset();
    $$(".alia-form-field", form).forEach(function (field) {
      field.classList.remove("is-filled", "is-invalid");
      delete field.dataset.touched;
      var control = formControl(field);
      if (control) control.removeAttribute("aria-invalid");
    });
    var status = $("#aliaFormStatus", form);
    if (status) status.textContent = "";
    syncOtherEventField(form);
    form.hidden = false;
    if (done) done.hidden = true;
    if (focusFirst) {
      var first = $("#aliaFormName", form);
      if (first) window.setTimeout(function () { first.focus({ preventScroll: true }); }, 30);
    }
  }

  function openEnquiry() {
    var dialog = $("#aliaEnquiry");
    if (!dialog) return;
    var form = $("#aliaEnquiryForm", dialog);
    var done = $("#aliaEnquiryDone", dialog);
    var prior = savedEnquiry();
    if (prior && prior.data && form) {
      showEnquiryConfirmation(dialog, form, true, true, prior.data);
    } else if (form) {
      form.hidden = false;
      var status = $("#aliaFormStatus", form);
      if (status) status.textContent = "";
      syncOtherEventField(form);
      if (done) done.hidden = true;
    }
    var date = $("#aliaFormDate", dialog);
    if (date) date.min = localDateMinimum();
    setHelp(false);
    setMenu(false);
    if (typeof dialog.showModal === "function") {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }
    document.body.classList.add("alia-dialog-open");
    var first = prior ? $("[data-alia-send-another]", dialog) : $("#aliaFormName", dialog);
    if (first) window.setTimeout(function () { first.focus({ preventScroll: true }); }, 30);
  }

  function closeEnquiry() {
    var dialog = $("#aliaEnquiry");
    if (!dialog) return;
    if (typeof dialog.close === "function" && dialog.open) dialog.close();
    else dialog.removeAttribute("open");
    document.body.classList.remove("alia-dialog-open");
  }

  function openGalleryImage(trigger) {
    var gallery = trigger && trigger.closest(".corporate-gallery");
    var dialog = gallery && $("[data-gallery-dialog]", gallery);
    var source = trigger && $(".corporate-gallery__image", trigger);
    var media = dialog && $("[data-gallery-lightbox-media]", dialog);
    if (!dialog || !source || !media) return;
    var target = $("img", media);
    if (!target) {
      target = document.createElement("img");
      media.appendChild(target);
    }
    var figure = trigger.closest(".corporate-gallery__item");
    var caption = figure && $(":scope > figcaption", figure);
    var captionTarget = $("[data-gallery-lightbox-caption]", dialog);
    target.src = source.currentSrc || source.src;
    target.alt = source.alt || "";
    if (captionTarget) captionTarget.textContent = caption ? caption.textContent.trim() : source.alt;
    dialog.__galleryReturnFocus = trigger;
    if (typeof dialog.showModal === "function") {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }
    document.body.classList.add("corporate-gallery-open");
  }

  function closeGalleryImage(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === "function" && dialog.open) dialog.close();
    else dialog.removeAttribute("open");
    document.body.classList.remove("corporate-gallery-open");
    var returnFocus = dialog.__galleryReturnFocus;
    if (returnFocus && returnFocus.isConnected && returnFocus.focus) returnFocus.focus({ preventScroll: true });
  }

  function formControl(field) {
    return $("input, select, textarea", field);
  }

  function syncFormField(field, touched) {
    var control = formControl(field);
    if (!control) return;
    if (touched) field.dataset.touched = "1";
    field.classList.toggle("is-filled", String(control.value || "").trim() !== "");
    if (field.dataset.touched === "1") {
      var invalid = !control.checkValidity();
      field.classList.toggle("is-invalid", invalid);
      control.setAttribute("aria-invalid", String(invalid));
    }
  }

  function syncOtherEventField(form) {
    if (!form) return;
    var eventType = $("#aliaFormEvent", form);
    var otherField = $("#aliaFormOtherField", form);
    var otherInput = $("#aliaFormOther", form);
    if (!eventType || !otherField || !otherInput) return;
    var showOther = eventType.value === "Something else";
    otherField.hidden = !showOther;
    otherInput.required = showOther;
    if (!showOther) {
      otherInput.value = "";
      otherField.classList.remove("is-filled", "is-invalid");
      delete otherField.dataset.touched;
      otherInput.removeAttribute("aria-invalid");
    }
  }

  function niceEnquiryDate(value) {
    if (!value) return "";
    var parts = value.split("-");
    if (parts.length !== 3) return value;
    try {
      return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])).toLocaleDateString("en-CA", {
        weekday: "long", month: "long", day: "numeric", year: "numeric"
      });
    } catch (error) {
      return value;
    }
  }

  function showEnquiryConfirmation(dialog, form, delivered, returning, data) {
    var status = $("#aliaFormStatus", form);
    if (!delivered) {
      if (status) status.textContent = "We could not submit this automatically. Please call (514) 566-2542.";
      return;
    }
    var doneTitle = $("#aliaDoneTitle", dialog);
    var doneCopy = $("#aliaDoneCopy", dialog);
    if (doneTitle) doneTitle.textContent = returning ? "Already sent." : "Request sent.";
    if (doneCopy) {
      doneCopy.textContent = returning
        ? "You already sent a corporate event request."
        : "Your details were sent to the ALIA corporate events team.";
    }
    renderEnquirySummary(dialog, data || {});
    var done = $("#aliaEnquiryDone", dialog);
    form.hidden = true;
    if (done) done.hidden = false;
  }

  async function submitEnquiry(form) {
    var dialog = form.closest("#aliaEnquiry");
    if (!dialog) return;
    var fields = $$(".alia-form-field", form);
    fields.forEach(function (field) { syncFormField(field, true); });
    if (!form.checkValidity()) {
      var invalid = $(".alia-form-field.is-invalid input, .alia-form-field.is-invalid select, .alia-form-field.is-invalid textarea", form);
      if (invalid) invalid.focus({ preventScroll: true });
      return;
    }

    var data = {};
    Array.prototype.forEach.call(form.elements, function (control) {
      var value = String(control.value || "").trim();
      if (!control.name || !value) return;
      if (!control.closest || !control.closest(".alia-form-field")) return;
      data[control.name] = value;
    });
    data.Site = leadConfig.site || leadConfig.domain || window.location.hostname;
    data.Page = window.location.href;
    renderEnquirySummary(dialog, data);

    var endpoint = leadConfig.endpoint || "";
    var submit = $('button[type="submit"]', form);
    var status = $("#aliaFormStatus", form);
    if (!endpoint) {
      if (status) status.textContent = "The request form is temporarily unavailable. Please call the event team.";
      return;
    }

    if (submit) {
      submit.disabled = true;
      submit.setAttribute("aria-busy", "true");
    }
    if (status) status.textContent = "Sending your request...";

    try {
      var response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(data),
        keepalive: true
      });
      if (!response.ok) throw new Error("Lead endpoint returned " + response.status);
      rememberEnquiry(data);
      showEnquiryConfirmation(dialog, form, true, false, data);
    } catch (error) {
      showEnquiryConfirmation(dialog, form, false);
    } finally {
      if (submit) {
        submit.disabled = false;
        submit.removeAttribute("aria-busy");
      }
    }
  }

  document.addEventListener("click", function (event) {
    var galleryTrigger = event.target.closest && event.target.closest("[data-gallery-open]");
    if (galleryTrigger) {
      event.preventDefault();
      openGalleryImage(galleryTrigger);
      return;
    }

    var galleryClose = event.target.closest && event.target.closest("[data-gallery-close]");
    if (galleryClose) {
      event.preventDefault();
      closeGalleryImage(galleryClose.closest("[data-gallery-dialog]"));
      return;
    }

    if (event.target.matches && event.target.matches("[data-gallery-dialog]")) {
      closeGalleryImage(event.target);
      return;
    }

    var menuToggle = event.target.closest && event.target.closest("[data-alia-menu-toggle]");
    if (menuToggle) {
      event.preventDefault();
      setMenu(menuToggle.getAttribute("aria-expanded") !== "true");
      return;
    }

    var enquiryTrigger = event.target.closest && event.target.closest("[data-alia-enquiry-open]");
    if (enquiryTrigger) {
      event.preventDefault();
      openEnquiry();
      return;
    }

    var sendAnother = event.target.closest && event.target.closest("[data-alia-send-another]");
    if (sendAnother) {
      event.preventDefault();
      forgetEnquiry();
      resetEnquiryForm(sendAnother.closest("#aliaEnquiry"), true);
      return;
    }

    var helpToggle = event.target.closest && event.target.closest("[data-alia-help-toggle]");
    if (helpToggle) {
      event.preventDefault();
      setHelp(helpToggle.getAttribute("aria-expanded") !== "true");
      return;
    }

    var dialogClose = event.target.closest && event.target.closest("[data-alia-dialog-close]");
    if (dialogClose) {
      event.preventDefault();
      closeEnquiry();
      return;
    }

    if (event.target.matches && event.target.matches("#aliaEnquiry")) {
      closeEnquiry();
      return;
    }

    var helpPanel = $("#aliaHelpPanel");
    var helpButton = $("[data-alia-help-toggle]");
    if (helpPanel && !helpPanel.hidden && !helpPanel.contains(event.target) && (!helpButton || !helpButton.contains(event.target))) setHelp(false);

    var nav = $("#nav");
    if (nav && nav.classList.contains("menu-open") && !nav.contains(event.target)) setMenu(false);

    var anchor = event.target.closest && event.target.closest('a[href^="#"]');
    if (anchor) {
      var id = anchor.getAttribute("href");
      var target = id && id.length > 1 ? document.querySelector(id) : null;
      if (target) {
        event.preventDefault();
        if (window.__lenis && window.__lenis.scrollTo) window.__lenis.scrollTo(target, { offset: -10 });
        else target.scrollIntoView({ behavior: reduce ? "auto" : "smooth" });
      }
      setMenu(false);
      return;
    }

    var question = event.target.closest && event.target.closest(".faq-q");
    if (!question) return;
    var item = question.closest(".faq-item");
    var answer = item && $(".faq-a", item);
    if (!item || !answer) return;
    var open = item.classList.contains("open");
    $$(".faq-item.open").forEach(function (other) {
      other.classList.remove("open");
      var otherAnswer = $(".faq-a", other);
      if (otherAnswer) otherAnswer.style.maxHeight = null;
    });
    if (!open) {
      item.classList.add("open");
      answer.style.maxHeight = answer.scrollHeight + "px";
    }
  });

  document.addEventListener("input", function (event) {
    var field = event.target.closest && event.target.closest(".alia-form-field");
    if (field) syncFormField(field, false);
  });

  document.addEventListener("change", function (event) {
    var field = event.target.closest && event.target.closest(".alia-form-field");
    if (field) syncFormField(field, false);
    if (event.target.matches && event.target.matches("#aliaFormEvent")) syncOtherEventField(event.target.form);
  });

  document.addEventListener("focusout", function (event) {
    var field = event.target.closest && event.target.closest(".alia-form-field");
    if (field) syncFormField(field, true);
  });

  document.addEventListener("submit", function (event) {
    if (!event.target.matches || !event.target.matches("#aliaEnquiryForm")) return;
    event.preventDefault();
    submitEnquiry(event.target);
  });

  document.addEventListener("cancel", function (event) {
    if (event.target.matches && event.target.matches("#aliaEnquiry")) document.body.classList.remove("alia-dialog-open");
    if (event.target.matches && event.target.matches("[data-gallery-dialog]")) document.body.classList.remove("corporate-gallery-open");
  }, true);

  document.addEventListener("close", function (event) {
    if (event.target.matches && event.target.matches("#aliaEnquiry")) document.body.classList.remove("alia-dialog-open");
    if (event.target.matches && event.target.matches("[data-gallery-dialog]")) document.body.classList.remove("corporate-gallery-open");
  }, true);

  window.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    setHelp(false);
    setMenu(false);
  });

  window.addEventListener("keydown", function (event) {
    if (event.key !== "g" && event.key !== "G") return;
    var flare = document.createElement("div");
    flare.style.cssText = "position:fixed;inset:0;z-index:9995;pointer-events:none;opacity:0;background:linear-gradient(105deg,rgba(138,95,58,0) 20%,rgba(138,95,58,.4) 46%,rgba(238,237,227,.35) 50%,rgba(138,95,58,.4) 54%,rgba(138,95,58,0) 80%);mix-blend-mode:screen";
    document.body.appendChild(flare);
    if (hasGSAP && !reduce) {
      gsap.fromTo(flare, { opacity: 0 }, {
        opacity: 1,
        duration: .28,
        ease: "power2.out",
        onComplete: function () {
          gsap.to(flare, { opacity: 0, duration: 1.1, ease: "power2.in", onComplete: function () { flare.remove(); } });
        }
      });
    } else {
      flare.style.opacity = "1";
      window.setTimeout(function () { flare.remove(); }, 400);
    }
  });

  var resizeTimer = 0;
  window.addEventListener("resize", function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      controllers.forEach(function (controller) { controller.resize(); });
      if (hasST) ScrollTrigger.refresh();
    }, 180);
  }, { passive: true });

  document.addEventListener("shopify:section:unload", function (event) {
    if ($("#aliaEnquiry", event.target)) document.body.classList.remove("alia-dialog-open");
    if ($("[data-gallery-dialog]", event.target)) document.body.classList.remove("corporate-gallery-open");
    cleanupScope(event.detail && event.detail.sectionId ? "shopify-section-" + event.detail.sectionId : event.target);
    window.requestAnimationFrame(function () {
      rebuildCrossBindings();
      if (hasST) ScrollTrigger.refresh();
    });
  });

  document.addEventListener("shopify:section:load", function (event) {
    if (pageBooted) {
      var injectedPreloader = $("#pre", event.target);
      if (injectedPreloader) injectedPreloader.classList.add("gone");
    }
    initScope(event.target, true);
    rebuildCrossBindings();
    tickCountdown();
    window.requestAnimationFrame(function () {
      if (hasST) ScrollTrigger.refresh();
    });
  });

  document.addEventListener("shopify:section:reorder", function () {
    rebuildCrossBindings();
    if (hasST) window.requestAnimationFrame(function () { ScrollTrigger.refresh(); });
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      controllers.forEach(function (controller) { controller.resize(); });
      if (hasST) ScrollTrigger.refresh();
    });
  }

  window.addEventListener("load", function () {
    if (hasST) window.setTimeout(function () { ScrollTrigger.refresh(); }, 120);
  });

  window.__goldenRoomRuntime = {
    refresh: function () {
      rebuildCrossBindings();
      tickCountdown();
      if (hasST) ScrollTrigger.refresh();
    }
  };
})();
